<script lang="ts">
	//Services
	import { format } from 'svelte-i18n';
	//Stores
	import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { getDeviceState } from 'src/stores/device-runtime/states';
	//Design system components
	import { Text, CircleAvatar } from '@Shelly/shelly-design-system';
	import { capFirstChar } from 'src/helpers/utilities';

	//Helpers
	import {
		getDeviceLastSeenData,
		getDeviceAvatarDefaultConfig,
	} from 'src/helpers/device_state_view_helpers';
	import {
		getCriticalNotifications,
		getNotificationsForDevice,
	} from 'src/helpers/notifications/device_notifications_helper';
	//Types
	import type { Device } from 'src/types/Device';

	export let device: Device;

	$: statusStore = getDeviceStatus(device?.id);
	$: settingsStore = getDeviceSettings(device?.id);
	$: status = $statusStore;
	$: settings = $settingsStore;

	$: notificationsToShow = getNotificationsForDevice(device?.id);

	$: criticalNotifications = getCriticalNotifications(notificationsToShow);

	$: lastSeenData = getDeviceLastSeenData(device, status, settings);

	$: deviceStateStore = getDeviceState(device?.id);
	$: deviceState = $deviceStateStore;
	$: isOffline = deviceState?.type === 0;
</script>

<CircleAvatar
	{...getDeviceAvatarDefaultConfig(device)}
	disabled={isOffline}
	borderStatus={criticalNotifications?.length && isOffline
		? { icon: 'fa-solid fa-shield-exclamation', color: 'color-warning' }
		: null}
/>

<Text class="mb-s text-bold text-center">
	{capFirstChar(
		$format('text_device_no_connection', {
			default: `No connection with ${device.name}.`,
			values: { deviceName: device.name },
		}),
	)}.
	{#if criticalNotifications.length}
		{capFirstChar(criticalNotifications[0].name)}
		{$format('text_detected', { default: 'detected' })}.
	{/if}
</Text>
{#if lastSeenData.lastSeenUpdate}
	<Text class="text-color-muted text-center" styleType="body-small">
		{capFirstChar(
			$format('text_last_active', {
				default: `Last active: ${lastSeenData.time}.`,
				values: { time: lastSeenData.time },
			}),
		)}
	</Text>
{/if}
